export default (state = {}, action) => {
    switch (action.type) {
        case 'LABELS':
            return action.payload.labels;
        default:
            return state;
    }
};
